import { call, put, takeLatest } from "redux-saga/effects";
import {
  miniGamesRewardsRequest,
  miniGamesRewardsSuccess,
  miniGamesRewardsFailure,
  MiniGamesRewardsData,
  jackpotHistoryRequest,
  jackpotHistorySuccess,
  jackpotHistoryFailure,
  JackpotHistoryData,
} from "./miniGamesRewardsActions";
import { getMiniGamesRewards, getJackpotHistory } from "../../services/api";

function* getMiniGamesRewardsWorker() {
  try {
    const data: MiniGamesRewardsData = yield call(getMiniGamesRewards);

    if (data) {
      yield put(miniGamesRewardsSuccess(data));
    } else {
      yield put(miniGamesRewardsFailure("Mini games rewards not found"));
    }
  } catch (e: any) {
    console.log("[saga] mini games rewards error:", e);
    const msg =
      e?.message ||
      e?.response?.data?.error ||
      "Failed to load mini games rewards";
    yield put(miniGamesRewardsFailure(msg));
  }
}

function* getJackpotHistoryWorker() {
  try {
    const data: JackpotHistoryData = yield call(getJackpotHistory);

    if (data) {
      yield put(jackpotHistorySuccess(data));
    } else {
      yield put(jackpotHistoryFailure("Jackpot history not found"));
    }
  } catch (e: any) {
    console.log("[saga] jackpot history error:", e);
    const msg =
      e?.message ||
      e?.response?.data?.error ||
      "Failed to load jackpot history";
    yield put(jackpotHistoryFailure(msg));
  }
}

export function* miniGamesRewardsRootSaga() {
  yield takeLatest(miniGamesRewardsRequest.type, getMiniGamesRewardsWorker);
  yield takeLatest(jackpotHistoryRequest.type, getJackpotHistoryWorker);
}
